module.exports = __webpack_public_path__ + "media/images/flags/16/Finland-4960021323088c7e827e6c34f9020dc2.png";